<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>更新书目库存信息</span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div>
          <el-upload class="upload-demo" ref="upload" action="......" :http-request="BSuploadFile"
            :before-upload="beforeUpload" :on-remove="changeFileLength" :on-change="changeFileLength"
            :auto-upload="false" :multiple="true">
            <el-button :disabled="selectFileBtnFlag" slot="trigger" icon="el-icon-folder-opened" size="small"
              type="primary" @click="selectFile">选取库存文件</el-button>
            <el-button :disabled="uploadFileBtnFlag" style="margin-left: 16px;" size="small" type="success"
              icon="el-icon-upload" @click="submitUpload">上传更新库存</el-button>

            <!-- <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
            <div slot="tip" class="el-upload__tip" style="color: red;">
              1、支持多个文件同时上传导入。<br>
              2、同一个供应商必须一次性都上传完，或者数据更新完之后再次上传。<br>
              3、Execl模板表格中的“供货商编号标志”在供货商管理中维护，如果找不到会在错误数据中统计。
            </div>
          </el-upload>
        </div>
      </el-col>
      <el-col :span="12">
        <div>
          <div style="height: 260px;">
            <el-steps direction="vertical" :active="stepIdx">
              <el-step icon="el-icon-folder-opened" title="选取库存文件"></el-step>
              <el-step icon="el-icon-upload" title="上传文件"></el-step>
              <el-step :icon="iconTxt" title="整理/统计验证库存文件数据......"></el-step>
              <el-step title="文件上传整理/统计结束" icon="el-icon-circle-check" :description="resResult"></el-step>
            </el-steps>
          </div>
        </div>
      </el-col>
      <el-col :span="24">
        <el-button type="primary" size="small" @click="cleanMsgList">清空更新进度信息</el-button>
        <!-- <el-button style="margin-left: 16px;" size="small" type="success" icon="el-icon-download"
          @click="downTemFile">下载模板文件</el-button> -->
      </el-col>
      <el-col :span="24">
        <el-divider content-position="left">供应商自己库存(线程)更新进度信息</el-divider>
        <div v-if="currBatch"
          style="max-width: 600px; width: 600px; margin: 10px 0; display: flex; align-items: center;">
          <span style="width: 100px; font-size: 16px; font-weight: bold;">处理进度</span>
          <div style="width: 100%;">
            <el-progress :text-inside="true" :stroke-width="20" :color="currProgress < 1 ? 'rgb(64, 158, 255)' :'rgb(103, 194, 58)'"
              :percentage="Math.floor(currProgress * 100)">
            </el-progress>
          </div>
        </div>

        <div v-for="(listItemLable, index) in msgAllData" :key="index">
          <el-descriptions class="margin-top" title="" :column="1" :size="'mini'">
            <el-descriptions-item :label="item.msgTime" v-for="(item, i) in listItemLable.dataList" :key="i">
              {{ item.msg }}
            </el-descriptions-item>
          </el-descriptions>
          <el-divider content-position="left"></el-divider>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { downFile } from "../../api/index";
import { mapGetters } from "vuex";
import axios from 'axios'
export default {
  name: "uploadBookCopy2",
  data() {
    return {
      tableData: [],
      url: {
        uploadUrl: "/front/provider/ayncUpdateStockWh",
        downloadUrl: "/common/downloadTemplate",
      },
      iconTxt: "el-icon-refresh",
      stepIdx: -1,
      resResult: "", // 上传更新结果信息
      filesLength: 0,
      BSfileList: [],
      selectFileBtnFlag: false,
      uploadFileBtnFlag: true,
      msgAllData: [],
      // 当前批次
      currBatch: '',
      // 当前进度，10% step1: 10-40%, step2: 40-90%, step3: 90-100%
      currProgress: 0,
      stepName: ['读取数据', '检测书库', '更新库存', '更新完成'],
      stepProgress: [0, 0.4, 0.95, 1],
      // 节点过渡占用进度
      guoduProgress: 0.1,
      currStepName: '',
      guoduTimer: null,
    };
  },
  computed: {
    ...mapGetters(["isNaName"]),
    updateWHStockUrl: function () {
      return `${this.baseurl + this.projectName}/${this.url.uploadUrl}` + '?whid='+ `${this.$store.state.userInfo.id}`
    },
    whsuMsgList() {
      return this.$store.state.socket.whsuMsgList
    },
  },
  watch: {
    whsuMsgList: {
      handler(newValue) {
        // console.log("whsuMsgList", newValue)
        if(newValue){
          this.handlerSocketMessage()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  created() {},
  methods: {
    // 进度节点过渡
    guoduStep(step) { 
      if (this.guoduTimer) { 
        clearInterval(this.guoduTimer)
        this.guoduTimer = null;
      }
      if(step >=3) return
      this.guoduTimer = setInterval(() => {
        if(this.currProgress >= this.stepProgress[step] + this.guoduProgress){
          clearInterval(this.guoduTimer)
          this.guoduTimer = null;
          return
        }
        this.currProgress += this.guoduProgress / 3
      }, 1000)
    },
    handlerSocketMessage(){
      const that = this
      var allData = []
      that.whsuMsgList.forEach((item) => {
        var dataList = []
        var msgThreadMap = new Map()
        const dataItem = item.onMsgList[item.onMsgList.length - 1]
        if (dataItem.batch == that.currBatch) { 
          this.guoduStep(0);
          if (["1", "2", "3"].includes(dataItem.threadId) && (dataItem.currCount && dataItem.totalCount)) {
            const startPro = that.stepProgress[dataItem.threadId - 1] + that.guoduProgress;
            const endPro = that.stepProgress[dataItem.threadId]
            that.currProgress = startPro + (dataItem.currCount / dataItem.totalCount) * (endPro - startPro);
            that.currStepName = that.stepName[dataItem.threadId];
            if (dataItem.currCount == dataItem.totalCount) this.guoduStep(dataItem.threadId)
            if (dataItem.threadId == 3) { 
              that.stepIdx = 4;
            }
          }
        }
        item.onMsgList.forEach((dataItem) => {
          // console.log('msgInfo',dataItem.msg,  dataItem)
          if(dataItem.threadId === '0'){
            dataList.unshift(dataItem)
          } else {
            if(dataItem.step == 40 || dataItem.step == 100){
            //   msgThreadMap.set("40", dataItem)
            // } else if() {
              msgThreadMap.set("100", dataItem)
            }  else {
              if(msgThreadMap.has(dataItem.threadId)){
                var mo = msgThreadMap.get(dataItem.threadId)
                if(dataItem.timeFlag >= mo.timeFlag && dataItem.step >= mo.step){
                  msgThreadMap.set(dataItem.threadId, dataItem)  
                }
              }else{
                msgThreadMap.set(dataItem.threadId, dataItem)
              }
            } 
          }
        })
        msgThreadMap.forEach((val) => {
          dataList.unshift(val)
        })
        allData.push({
          dataList: dataList,
          specialLabel: item.specialLabel,
          batch: item.batch,
        })
      })
      that.msgAllData = allData
    },
    selectFile() { // 选择文件
      this.stepIdx = 0;
      this.resResult = "";
      this.currBatch = '';
      this.currProgress = 0
    },
    submitUpload() {
      console.log('点击上传')
      const that = this
      that.stepIdx = 1;
      that.$refs.upload.submit();
     
      console.log('开始上传' , that.BSfileList.length, that.BSfileList.length == that.filesLength)
      if(that.BSfileList.length <= 0 || that.filesLength <= 0){
        that.$message.error('请选择文件！');
        return false
      }
      if(that.BSfileList.length >100){
        that.$message.error('最多能同时上传100个文件！');
        return false
      }
      // 当BSfileList长度等于用户需要上传的文件数时进行上传
      if (that.BSfileList.length == that.filesLength){

        this.uploadFileBtnFlag = true
        this.selectFileBtnFlag = true

        // 创建FormData上传
        let fd = new FormData()
        // 将全部文件添加至FormData中
        that.BSfileList.forEach((file, index) => {
          // 第一个参数可改，看后台接口接收什么就改成什么。
          // 第二个参数，是没一个文件的文件流，有时候是file，有时候是file.raw
          // 打印出来，根据时间情况来传入。我也不知道为什么，可能是elm版本封装的json格式不一样
          fd.append('file' + index, file.raw)
        })
        // 配置请求头，基本上所有上传文件用的都是form-data类型
        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          }
        }
        
        that.fileProgress()

        axios.post(that.updateWHStockUrl,fd, config).then(res=>{
          // 上传成功后的处理
          // console.log("文件上传完毕：",res)
          that.currBatch = res.data.result;
          that.currStepName = that.stepName[0];
          that.fileSuccess(res.data.message)
        },err=>{
          // 出现错误时的处理
          // console.log("文件上传完毕：",err)
          that.fileSuccess(err.data.message)
        })  
      }

    },
    fileSuccess(msg) {
      this.iconTxt = "el-icon-refresh";
      this.stepIdx = 3;
      this.resResult = msg + " 可以关闭页面。"
      //清空上传的文件
      this.$refs.upload.clearFiles();
      this.filesLength = 0
      this.BSfileList = []
      this.uploadFileBtnFlag = true
      this.selectFileBtnFlag = false

    },
    fileProgress() { // 开始
      this.iconTxt = "el-icon-loading";
      this.stepIdx = 2;
    },
    // 自定义上传文件，也就是上传到服务器的方法
    BSuploadFile(){
      // 此处是空方法
    },
    downTemFile() {
      downFile(this.url.downloadUrl, { flag: "2" }).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let a = document.createElement("a");
        a.setAttribute(
          "download",
          "上传书目库存更新模板.xlsx"
        );
        a.href = url;
        a.click();
      });
    },
    // 上传到服务器前的校验
    beforeUpload(file) {
      console.log('上传前：',file)
      // // 打印出来看一下格式，file流有时候在file.raw中
      // if (file&&file.type) {
      //   const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/png');
      //   const isLt1M = file.size / 1024 / 1024 < 1;

      //   if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG、PNG 格式!');
      //   }
      //   if (!isLt1M) {
      //     this.$message.error('上传头像图片大小不能超过 1MB!');
      //   }
      //   return isJPG && isLt1M;
      // } else {
      //   this.$message.error('文件格式错误，请检查！');
      //   return false
      // }
    },
    // 选择文件，修改当前文件列表长度后
    changeFileLength(singleFile, fileList){
      console.log('修改当前文件', singleFile, fileList)
      this.filesLength = fileList.length
      this.BSfileList = fileList
      if(fileList.length > 0){
        this.uploadFileBtnFlag = false
      }else{
        this.uploadFileBtnFlag = true
      }
    },
    cleanMsgList(){
      const that = this
      that.currBatch = ''
      that.msgAllData = []
      that.$store.commit('socket/cleanWarehouseStockUpdateMsgList')
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
.el-cascader {
  display: block;
}
</style>
